/* eslint-disable import/first */

import React, { Component } from 'react';
import ls from 'local-storage';

import AsyncComponent from '../../Components/AsyncComponent';
import Landing from '../../Components/Landing';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import SideBarOptions from '../../Components/SideBarOptions/SideBarOptions';
import { AvailableScreenOptions } from '../../Components/SideBarOptions/OptionValues';

import './App.css';

const jwtDecode = require('jwt-decode');

const AsyncActivityFeed = AsyncComponent(() => import('../../Components/ActivityFeed'));
const AsyncDailyWod = AsyncComponent(() => import('../../Components/DailyWod'));
const AsyncDailyWodV2 = AsyncComponent(() => import('../../Components/DailyWodV2'));
const AsyncActivityFeedV2 = AsyncComponent(() => import('../../Components/ActivityFeedV2'));
const OpenLeaderboard = AsyncComponent(() => import('../../Components/OpenLeaderboard'));

import firebase from "firebase/app";

// Required for side-effects
require("firebase/firestore");

// Hmm, this feels very not good RE: React
firebase.initializeApp({
  apiKey: '  AIzaSyAUPIzKdGeA4xyQAUjbo6Zg1pQ6REF0sPY ',
  authDomain: 'btwb-thewire.firebaseapp.com',
  projectId: 'btwb-thewire'
});

// Hellz yeah globos bb
const db = firebase.firestore();
// const ROUTE_CHANGE_DUR = 500;
const namespace = 'urn:x-cast:com.google.cast.mainbus.messsagingMaster';

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      gym: {
        loading:true,
        error: false,
      },
      gymID: undefined,
      ourFirebaseObject: {},
      route: '/',
      screenSize: undefined,
      // these are customized from the sender
      themeColor: '#e84924', //
      displayedWods: 4,
      timeToSwitch: 5000,
      scrollSpeed: 3000,
      tracks: [],
      distance: 'close',
      distanceNumber: 4,
      selectedWods: [],
      autoRotate: false,
      activeDivisions: ['individuals__all'],
      weightUnits: 'lbs',
      sideBarOpen: false,
    }

    this.handleGymId = this.handleGymId.bind(this);
    this.castSetup = this.castSetup.bind(this);
    this.changeRoute = this.changeRoute.bind(this);
    this.sendOptions = this.sendOptions.bind(this);
    this.updateTracks = this.updateTracks.bind(this);
    this.sendWods = this.sendWods.bind(this);
    this.getOldOptions = this.getOldOptions.bind(this);

    this.getScreenOptions = this.getScreenOptions.bind(this);
    this.updateScreenOptions = this.updateScreenOptions.bind(this);
    this.openSideBar = this.openSideBar.bind(this);
    this.closeSideBar = this.closeSideBar.bind(this);
    this.getUpdatedWods = this.getUpdatedWods.bind(this);
  }

  changeRoute(arg) {
    if(arg.indexOf('https://') > -1) return window.location.href = arg;
    this.setState({
      route: arg
    });
  }

  handleGymId(id, context) {
    if(!id) return;

    this.setState({
      ourFirebaseObject: db.collection('wodscreen.v2018.gyms').doc(id)
    });

    db
      .collection('wodscreen.v2018.gyms')
      .doc(id)
      .get()
      .then((snapshot) => {

        let data;

        if(snapshot.exists) {
          data = snapshot.data();
          this.setState({
            gym: data,
            gymID: id,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          gym: {
            loading: false,
            error: true,
          }
        });
      })
  }

  castSetup() {
      return;
    console.log('Version4.2PATCH');
    const cast = window.cast;

    if(!cast.framework){
      console.log('ERROR');
      return;
    } else {
      const context = cast.framework.CastReceiverContext.getInstance();
      const options = new cast.framework.CastReceiverOptions();
      const playerManager = context.getPlayerManager();

      // fake load on here, so receiver can disconnect
      window.setInterval(() => {
        const message = new cast.framework.messages.LoadRequestData();
        message.media.contentId = 'https://meegan.xyz/fake/f3762c91.pic-o-me.jpg';
        message.media.contentType = 'image/jpeg';
        playerManager.load(message)
          .then((res) => {
            // console.log(res);
            return;
          }).catch((err) => {
            console.log(err);
            return true;
          });
      }, 90000);

      // custom listeners for our custom sender messages
      context.addCustomMessageListener(namespace, (customEvent) => {

        if(customEvent.data) {
          // split out our master messaging here -- we can pass our vars through props to the views, or handle appwide changes here (IE location)
          if(customEvent.data.parameter === 'location') {
            return this.changeRoute(customEvent.data.result);
          } else if(customEvent.data.parameter === 'reqLocation') {
            this.sendOptions(context);
            if(this.state.tracks.length > 0 || this.state.tracks[0] === '') {
              context.sendCustomMessage(namespace, undefined, 'tracks:' + this.state.tracks.join(','));
            } else if (this.state.tracks.length === 0) {
              context.sendCustomMessage(namespace, undefined, 'tracksAll:true');
            }
            return context.sendCustomMessage(namespace, undefined, 'screen:' + this.state.route);
          } else if(customEvent.data.parameter === 'options') {
            // handle options push
            this.getOldOptions(customEvent, context);
          // Track updater
          } else if(customEvent.data.parameter === 'tracks') {
            this.updateTracks(customEvent.data.result, context);
          } else if(customEvent.data.parameter === 'gymID')  {
            if(!this.state.gymID) {
              this.setState({
                gymID: customEvent.data.result
              }, () => {
                // console.log('hitting this thing');
                return this.handleGymId(customEvent.data.result, context);
              });

            }
          } else if(customEvent.data.parameter === 'sendWods'){
            this.sendWods(this.state.selectedWods);
          } else if(customEvent.data.parameter === 'updateWods') {
            this.setState({selectedWods: customEvent.data.result}, () => this.sendWods(this.state.selectedWods));
          } else {
            console.log(customEvent.data)
          }
        }
      });

      // If a sender is connected, failsafe to catch if it's reconnected vs connected initally
      context.addEventListener(cast.framework.system.EventType.SENDER_CONNECTED, (event) => {
        if(this.state.ourGymObject !== null) {
          this.sendOptions(context);
          return context.sendCustomMessage(namespace, undefined, 'successfulID');
        } else {
          return context.sendCustomMessage(namespace, undefined, 'missing');
        }
      });


      // context.stop();
      context.start(options);

    }
  }

  getScreenOptions() {
    const {
      themeColor,
      timeToSwitch,
      scrollSpeed,
      distanceNumber,
      weightUnits,
      selectedWods,
      displayedWods,
      tracks,
    } = this.state;

    return {
      themeColor,
      timeToSwitch,
      scrollSpeed,
      distanceNumber,
      weightUnits,
      selectedWods,
      displayedWods,
      tracks,
    };
  }

  updateScreenOptions(newValue, e) {
    const { option, wods } = newValue;

    if (option === 'selectedWods') {
      this.setState({
        selectedWods: this.getUpdatedWods(wods)
      });
    } else {
      let newState = {};
      newState[option] = e.target.value;

      this.setState(newState);
    }
  }

  openSideBar() {
    this.setState({
      sideBarOpen: true,
    });
  }

  closeSideBar() {
    this.setState({
      sideBarOpen: false,
    });
  }

  getUpdatedWods(wods) {
    let newWods = [];

    if(!wods) {
      wods = this.state.selectedWods;
    }

    wods.map(wod => {
      // build our new WODs options object -- reduce request size
      let newWod = {};
      newWod.show = wod.show;
      newWod.video = wod.video;
      newWod.leaderboard = wod.leaderboard;
      newWod.title = wod.title ? wod.title : wod.workout_name;
      newWod.id = wod.id;
      newWod.track_name = wod.track_name;
      return newWods.push(newWod);
    });

    return newWods;
  }

  sendOptions(context) {

    // depreciated, reactivate so non-updated users can still use it
    context.sendCustomMessage(namespace, undefined, 'options:' +
      this.state.themeColor +
      ',' +
      this.state.timeToSwitch +
      ',' +
      this.state.displayedWods +
      ',' +
      this.state.scrollSpeed +
      ',' +
      this.state.distance +
      ',' +
      this.state.themeTint +
      ',' +
      this.state.distanceNumber +
      ',' +
      this.state.activeDivisions +
      ',' +
      this.state.weightUnits
    )


    // new options should be sent back here. Future versions will not be using the 'options call'
    context.sendCustomMessage(namespace, undefined, {
      parseableOptions: {
        themeColor: this.state.themeColor,
        timeToSwitch: this.state.timeToSwitch,
        displayedWods: this.state.displayedWods,
        scrollSpeed: this.state.scrollSpeed,
        distance: this.state.distance,
        tintColor: this.state.themeTint,
        distanceNumber: this.state.distanceNumber,
        autoRotate: this.state.autoRotate,
        activeDivisions: this.state.activeDivisions,
        weightUnits: this.state.weightUnits
      }
    })
  }

  getOldOptions(customEvent, context) {
    let keyVals = customEvent.data.result.split(',');
    let optionReplacer = {};
    // force parse if option val is #
    console.log(customEvent);

    // HACK: force through division option
    if(keyVals[0] === 'divisions') {
      keyVals.shift();
      return this.setState({
        activeDivisions: keyVals
      }, () => {
        this.sendOptions(context);
      })
    }
    if( !isNaN(parseInt(keyVals[1])) ) keyVals[1] = parseInt(keyVals[1]);
    optionReplacer[keyVals[0]] = keyVals[1];
    this.setState(optionReplacer, () => {
      this.sendOptions(context);
    })
  }

  sendWods(wods) {
    // const context = window.cast.framework.CastReceiverContext.getInstance();
    const newWods = this.getUpdatedWods(wods);

    return this.setState({
      selectedWods: newWods
    }, () => {
      return;
      if (process.env.REACT_APP_ENV !== 'dev') {
        // console.log(JSON.stringify(this.state.selectedWods));
        // return context.sendCustomMessage(namespace, undefined, {selectedWods: newWods});
      }
    });

  }

  updateTracks(tracks, context) {
    if(!tracks.split(',')) return;
    this.setState({
      tracks: tracks.split(',')
    }, () => {
      return;
      // context.sendCustomMessage(namespace, undefined, 'tracks:' + this.state.tracks.join(','));
    });

  }

  componentDidMount() {
    console.log('updated-v9');
    /*if(process.env.REACT_APP_ENV !== 'dev') {
      this.castSetup();
    } else {*/
      // console.warn('dev mode');
      // TODO: might need to pollyfill URLSearchParams depending on browser support
      // Slice to remove the initial `?`
      let urlParams = new URLSearchParams(window.location.search.slice(1));

      // Check localstorage for gymScope
      let gymScope = ls.get('gymScope');

      if (!gymScope && urlParams.has('jwt')) {
        // There's no gymScope in localStorage
        // Check url params for a jwt token
        const jwtToken = urlParams.get('jwt');
        const decodedToken = jwtDecode(jwtToken);

        // Get gymScope from jwt token and update local storage
        if (decodedToken.scopes) {
          gymScope = decodedToken.scopes[0];
          ls.set('gymScope', gymScope);
        }

        // remove `jwt` param from URL
        // Slice to remove the initial `%3F`
        urlParams.delete('jwt');
        const urlParamsStr = urlParams.toString();
        const newLocationString = `${window.location.origin}${window.location.pathname}${urlParamsStr ? `?${urlParamsStr.slice(3)}` : ''}`;

        // Update browser location string
        // TODO: browser support for history API ok?
        window.history.pushState({}, '', `${newLocationString}`);
      }

      if (gymScope) {
        // We have a gym scope, so continue with rendering the app
        // Test scope: _z63
        // this.handleGymId('_keff');
        this.handleGymId(gymScope);
      } else {
        // Failed to get a gym scope, so set error state
        this.setState({
          gym: {
            loading: false,
            error: true,
          }
        });
      }
    // }

    let width = window.innerWidth;

    this.setState({
      screenSize: width < 1800 ? 'small' : 'large'
    })
  }


  render() {
    const allScreenOptions = this.getScreenOptions();
    const availableOptions = AvailableScreenOptions[`${this.state.route.slice(1)}`];

    return (
      <div className={'App ' + this.state.screenSize + ' ' + this.state.distance}>
        {(this.state.route !== '/daily-wod-2' && this.state.route !== '/activity-feed-2' && this.state.route !== '/activity-feed' && this.state.route !== '/daily-wod' && this.state.route !== '/open-leaderboard')  &&
          <Header
            gym={this.state.gym}
            pageTitle={this.state.route.replace('/', '').replace('-', ' ')}
            themeColor={this.state.themeColor}
          />
        }
        {this.state.route === '/daily-wod' &&
          <AsyncDailyWod
            route={this.state.route}
            ourFirebaseObject={this.state.ourFirebaseObject}
            namespace={namespace}
            displayedWods={this.state.displayedWods}
            themeColor={this.state.themeColor}
            timeToSwitch={this.state.timeToSwitch}
            gym={this.state.gym}
            tracks={this.state.tracks}
          />
        }
        {this.state.route === '/activity-feed' &&
          <AsyncActivityFeed
            route={this.state.route}
            ourFirebaseObject={this.state.ourFirebaseObject}
            namespace={namespace}
            scrollSpeed={this.state.scrollSpeed}
            themeColor={this.state.themeColor}
            timeToSwitch={this.state.timeToSwitch}
            gym={this.state.gym}
            tracks={this.state.tracks}
          />
        }
        {this.state.route === '/daily-wod-2' &&
          <AsyncDailyWodV2
            route={this.state.route}
            ourFirebaseObject={this.state.ourFirebaseObject}
            namespace={namespace}
            gym={this.state.gym}
            sendWods={this.sendWods}
            onSideBarOpen={this.openSideBar}
            {...allScreenOptions}
          />
        }
        {this.state.route === '/activity-feed-2' &&
          <AsyncActivityFeedV2
            route={this.state.route}
            ourFirebaseObject={this.state.ourFirebaseObject}
            gym={this.state.gym}
            sendWods={this.sendWods}
            autoRotate={this.state.autoRotate}
            onSideBarOpen={this.openSideBar}
            {...allScreenOptions}
          />
        }
        {this.state.route === '/open-leaderboard' &&
          <OpenLeaderboard
            route={this.state.route}
            ourFirebaseObject={this.state.ourFirebaseObject}
            themeColor={this.state.themeColor}
            gym={this.state.gym}
            id={this.state.gymID}
            db={db}
            selectedWods={this.state.selectedWods}
            timeToSwitch={this.state.timeToSwitch}
            scrollSpeed={this.state.scrollSpeed}
            autoRotate={this.state.autoRotate}
            activeDivisions={this.state.activeDivisions}
          />
        }
        {this.state.route === '/' &&
          <Landing
            route={this.state.route}
            themeColor={this.state.themeColor}
            gym={this.state.gym}
            changeRoute={this.changeRoute}
          />
        }
        {this.state.route !== '/' &&
          <SideBarOptions
            open={this.state.sideBarOpen}
            onChange={this.updateScreenOptions}
            onClose={this.closeSideBar}
            availableOptions={availableOptions}
            {...allScreenOptions}
           />
        }
        {(this.state.route !== '/daily-wod-2' && this.state.route !== '/activity-feed-2' && this.state.route !== '/open-leaderboard') &&
          <Footer gym={this.state.gym} />
        }
      </div>
    );
  }
}

export default App;
